import React,{forwardRef,useEffect,useImperativeHandle, useState} from "react";
import AddressForm from "./Utils/AddressForm";
import {connect} from "react-redux";
import Joi from "joi";
import * as actions from "../../store/actions/index";
import Spinner from "../Spinner/Spinner"
import AddressCard from "./Utils/AddressCard";
import Modal from "../UI/Modal/Modal";
import FlexContainerNoWrap from "../UI/FlexContainerNoWrap/FlexContainerNoWrap"
const Address = forwardRef((props,ref)=>{
    const [isAddressNotAvailable,setAddressStatus] = useState(false);
    const [address,setAddress] = useState({ })
    const [addresses, setAddresses] = useState([])
    const [modalVisible,setModal] = useState(false) 
    const [newAddressModal,setNewAddressModal] = useState(false)
    const [loading,setLoading] = useState(false)

    const schema = Joi.object({
        id:Joi.string(),
        firstname:Joi.string().trim().max(20).required(),
        lastname:Joi.string().trim().max(30).required(),
        emailaddress:Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net','in'] } }).required(),
        country:Joi.string().required(),
        streetaddress:Joi.string().trim().max(100).required(),
        landmark:Joi.string().trim().max(50).required(),
        state:Joi.string().required(),
        city:Joi.string().trim().required().max(30),
        pincode:Joi.string().trim().min(6).max(6).required(),
        phone:Joi.string().trim().min(10).max(10).required(),
        businessname:Joi.string().trim().max(40),
        businessgst:Joi.string().trim().max(50)

    })

    useImperativeHandle(ref, () => ({

         proceed () { 
            
          return new Promise(async (resolve,reject)=>{
            try{
                        //validation code
                    if(isAddressNotAvailable){
                        //validate and add address
                        let {error} = schema.validate(address);
                        if(error){
                            return alert(error)
                        }else{
                            //submit address to backend
                            props.setLoading(true)
                            await props.createAddress(address,props.user)
                            props.setLoading(false)
                            return resolve(true)
                        }
                        
                    }else{ 
                      
                        if(!props.order.address){
                            alert("Please select a address");
                            return resolve(false)
                        }
                        //check if address added to order object
                        //Add address to order object
                    // return true
                    }
            
            }catch(error){
                props.setLoading(false)
                alert(error)
                return resolve(false)
            }
          })



        } 
    
      })); 

      useEffect(()=>{ 
      
        props.setVisibility(false)
        if(props.user){

         try{
            if(Object.keys(props.user.addresses).length){
              
                props.setVisibility(false)
                let addresses = props.user.addresses;
                let addressArr = [];
                for(let ak in addresses){
                    addressArr.push(addresses[ak])
                } 
                setAddresses(addressArr);
            }else{
                
                props.setVisibility(true)
                setAddressStatus(true)
                 
            } 
         } catch(error){
             
         } 
        }

      },[props.user])

      const handleDeliverToAddress = async (address)=>{
           try{
                await props.selectAddress(address)
                props.moveDirectly("forward")
                props.setVisibility(true)
           }catch(error){
               return alert(error)
           }
      }
      const handleEdit = (address)=>{
        setAddress(address)
        setModal(true)
      }
      const handleDelete = async(address)=>{
        try{

            setLoading(true)
            await props.deleteAddress(address.id,props.user)
            setLoading(false)
            window.location.reload(false)
        }catch(error){
            return alert(error)
        }
        

      }
      if(!props.user){
          return <Spinner/>
      }
      return(
          <div className="container">
              {isAddressNotAvailable?<AddressForm setAddress={setAddress} />:null}

              {
                 addresses.length?(
                    <div>
                        <button className="btn btn-outline-secondary btn-sm mb-3"
                            onClick={()=>setNewAddressModal(true)}
                        >Create Address</button>
                    </div>
                     
                 ):null
             }
            <FlexContainerNoWrap>

                {
                        addresses.map(add=>(
                            <AddressCard 
                                address={add}
                                handleDeliverToAddress={handleDeliverToAddress}
                                handleEdit={handleEdit}
                                handleDelete={handleDelete}
                                loading={loading}
                            />
                        ))
                    } 
                

            </FlexContainerNoWrap>
            
                  
               
              
              { 
                modalVisible&&( 
                     <Modal
                     show={modalVisible}
                     modalClosed={() =>setModal(false)}
                     modalStyle={{
                        width: "93%",
                        left: "4%",
                        overflowY: "scroll",
                        maxHeight: "70%",
                        top:"15%"
                      }}
                     >
                      <AddressForm address={address}
                        editAddress={props.editAddress}
                        user={props.user}
                        setModal={setModal}
                      /> 
                  </Modal>)
              }
              {
                  newAddressModal&&(
                      <Modal
                        show={newAddressModal}
                        modalClosed={() =>setNewAddressModal(false)}
                        modalStyle={{
                            width: "93%",
                            left: "4%",
                            overflowY: "scroll",
                            maxHeight: "70%",
                            top:"15%"
                          }}
                      >
                        <AddressForm 
                            setAddress={setAddress} 
                            showSubmit={true}
                            editAddress={props.createAddress}
                            user={props.user}
                            setModal={setNewAddressModal}
                        />
                      </Modal>
                  )
              }
          </div>
      )
}) 

const mapStateToProps = state=>{
    return{
        user:state.auth.user,
        order:state.cart.order,

    }
}
const mapDispatchToProps = dispatch=>{
    return{
        createAddress:(address,user)=>dispatch(actions.createAddress(address,user)),
        selectAddress:(address)=>dispatch(actions.selectAddress(address)),
        editAddress:(address,user)=>dispatch(actions.editAddress(address,user)),
        deleteAddress:(id,user)=>dispatch(actions.deleteAddress(id,user))
    }
}
export default  connect(mapStateToProps, mapDispatchToProps,null,{ forwardRef: true })(Address)
//export default Address